import React, { useMemo } from 'react';

import { selectAllId, WITHOUT_DEPARTMENTS_ID } from 'pages/tasks/constants';
import type { selectedDate, TreeNode } from 'types/interfaces';

import { CustomDropdown } from 'ui/custom-controls';
import Datepicker from 'ui/custom-controls/Datepicker';

import { DistributionSingleDayPicker } from './DistributionSingleDayPicker';
import './DistributionFiltersHeader.css';

interface Props {
  isDepartmentsLoaded: boolean;
  treeDropDownValue: TreeNode[];
  selection: TreeNode[];
  onSelectionChange: (next: TreeNode[]) => void;
  dateFilter: selectedDate;
  onDateFilterChange: (next: selectedDate) => void;
  onSingleDayChange: (date: Date) => void;
  travelTimeOptimization: boolean;
}

export const DistributionFiltersHeader: React.FC<Props> = ({
  isDepartmentsLoaded,
  treeDropDownValue,
  selection,
  onSelectionChange,
  dateFilter,
  onDateFilterChange,
  onSingleDayChange,
  travelTimeOptimization
}) => {
  const departmentOptions = useMemo(
    () =>
      treeDropDownValue.filter(
        (node) =>
          node.key !== WITHOUT_DEPARTMENTS_ID && node.key !== selectAllId
      ),
    [treeDropDownValue]
  );

  return (
    <div className="flex flex-wrap gap-3 align-items-end">
      <div>
        {isDepartmentsLoaded ? (
          <div style={{ width: '270px' }}>
            <CustomDropdown<TreeNode>
              assetOptions={[]}
              treeValue={departmentOptions}
              useTree
              selectedAsset={selection[0] ?? null}
              onTreeSelectionChange={(next) =>
                onSelectionChange(Array.isArray(next) ? next : [next])
              }
              passedClassName={
                selection.length === 0
                  ? 'distribution-department-invalid'
                  : undefined
              }
              fixedLabel={selection[0]?.label || 'Выбор участка'}
              placeholder="Выбор участка"
              overlayWidthMultiplier={1.5}
              customHeight={400}
            />
          </div>
        ) : (
          <span className="text-500">Участки загружаются…</span>
        )}
      </div>
      {travelTimeOptimization ? (
        <DistributionSingleDayPicker
          dateFilter={dateFilter}
          onChange={onSingleDayChange}
        />
      ) : (
        <Datepicker
          key={JSON.stringify(dateFilter)}
          datepickerDate={dateFilter}
          onChange={onDateFilterChange}
          customTooltips={{
            from: 'Дата регистрации с',
            until: 'Дата регистрации по'
          }}
        />
      )}
    </div>
  );
};
